"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxOnboarding = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _variables = require("../../../global-files/variables");

var _BoxAttribute = require("../../molecules/BoxAttribute");

var _react = require("react");

var _lodash = require("lodash");

var _jsxRuntime = require("react/jsx-runtime");

var BoxOnboarding = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var panelColor = _ref.panelColor,
      index = _ref.index,
      onChange = _ref.onChange,
      data = _ref.data,
      dataInputs = _ref.dataInputs,
      inputs = _ref.inputs;

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      atributos = _useState2[0],
      setAtributos = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  (0, _react.useEffect)(function () {
    onChange && onChange(atributos);
  }, [atributos]);
  (0, _react.useEffect)(function () {
    if (isLoading && Object.keys(data).length > 0) {
      setAtributos(data);
      setIsLoading(false);
    }
  }, [data]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    panelColor: panelColor,
    fontFamily: _variables.FontFamily.Raleway,
    color: _variables.GlobalColors.original_magenta,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: "contenedor-caja",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        fontFamily: _variables.FontFamily.Raleway,
        children: ["Caja ", index + 1]
      }), inputs.map(function (attrId) {
        var _dataInputs$attrId, _dataInputs$attrId2, _dataInputs$attrId3;

        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BoxAttribute.BoxAttribute, {
          id: attrId,
          borderType: "rectangle",
          className: "caja",
          text: (_dataInputs$attrId = dataInputs[attrId]) === null || _dataInputs$attrId === void 0 ? void 0 : _dataInputs$attrId.name,
          required: (_dataInputs$attrId2 = dataInputs[attrId]) === null || _dataInputs$attrId2 === void 0 ? void 0 : _dataInputs$attrId2.required,
          description: (_dataInputs$attrId3 = dataInputs[attrId]) === null || _dataInputs$attrId3 === void 0 ? void 0 : _dataInputs$attrId3.description,
          atributos: atributos,
          setAtributos: setAtributos
        }, attrId);
      })]
    })
  });
}, _lodash.isEqual);
exports.BoxOnboarding = BoxOnboarding;